import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { PrivateComponent } from './private.component';

@NgModule({
  imports: [SharedModule],
  declarations: [PrivateComponent],
  exports: [PrivateComponent],
})
export class PrivateModule {}
